/**
 * Article FAQ Accordion — Dot Trail Timeline
 * Transforms static .ines-faq-item divs (h3 + p) into <details> accordions
 * matching the FAQ page design (ines-faq.liquid).
 */

(function () {
  'use strict';

  function initArticleFaq() {
    var items = document.querySelectorAll('.ines-faq-item');
    if (!items.length) return;

    items.forEach(function (div) {
      var h3 = div.querySelector('h3');
      if (!h3) return;

      /* ── Build <details> to replace the <div> ── */
      var details = document.createElement('details');
      details.className = div.className; // preserve ines-faq-item

      /* ── <summary> with question text + chevron ── */
      var summary = document.createElement('summary');
      summary.className = 'ines-faq-item__question';

      var span = document.createElement('span');
      span.textContent = h3.textContent;
      summary.appendChild(span);

      var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('class', 'ines-faq-item__chevron');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('fill', 'none');
      svg.setAttribute('stroke', 'currentColor');
      svg.setAttribute('stroke-width', '2.5');
      svg.setAttribute('stroke-linecap', 'round');
      svg.setAttribute('stroke-linejoin', 'round');
      svg.setAttribute('aria-hidden', 'true');
      var polyline = document.createElementNS('http://www.w3.org/2000/svg', 'polyline');
      polyline.setAttribute('points', '6 9 12 15 18 9');
      svg.appendChild(polyline);
      summary.appendChild(svg);

      details.appendChild(summary);

      /* ── Answer wrapper ── */
      var answer = document.createElement('div');
      answer.className = 'ines-faq-item__answer';
      var inner = document.createElement('div');
      inner.className = 'ines-faq-item__answer-inner';

      /* Move all content except h3 into the answer */
      var children = Array.from(div.children);
      children.forEach(function (child) {
        if (child !== h3) {
          inner.appendChild(child);
        }
      });
      answer.appendChild(inner);
      details.appendChild(answer);

      /* ── Replace original div ── */
      div.parentNode.replaceChild(details, div);

      /* ── Smooth accordion animation ── */
      attachAccordion(details, summary, answer);
    });
  }

  function attachAccordion(details, summary, content) {
    content.style.transition = 'max-height 0.35s ease, opacity 0.3s ease';

    summary.addEventListener('click', function (e) {
      e.preventDefault();

      if (details.open) {
        /* Closing */
        details.classList.remove('is-open');
        content.style.maxHeight = content.scrollHeight + 'px';
        requestAnimationFrame(function () {
          content.style.maxHeight = '0px';
          content.style.opacity = '0';
        });
        var closeTimer = setTimeout(function () {
          details.open = false;
          content.style.maxHeight = '';
          content.style.opacity = '';
        }, 400);
        content.addEventListener('transitionend', function handler() {
          clearTimeout(closeTimer);
          details.open = false;
          content.style.maxHeight = '';
          content.style.opacity = '';
          content.removeEventListener('transitionend', handler);
        });
      } else {
        /* Opening */
        details.open = true;
        details.classList.add('is-open');
        var h = content.scrollHeight;
        content.style.maxHeight = '0px';
        content.style.opacity = '0';
        requestAnimationFrame(function () {
          content.style.transition = 'max-height 0.35s ease, opacity 0.3s ease';
          content.style.maxHeight = h + 'px';
          content.style.opacity = '1';
        });
        content.addEventListener('transitionend', function handler() {
          content.style.maxHeight = '';
          content.style.transition = '';
          content.removeEventListener('transitionend', handler);
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initArticleFaq);
  } else {
    initArticleFaq();
  }
})();
